import React from 'react';
import { Card, Table, Tag, Progress, Empty } from 'antd';
import { Link } from 'react-router-dom';
import paths from 'assets/routes/paths';

const columns = [
  {
    title: 'Ascensor',
    dataIndex: 'nombre',
    key: 'nombre',
    render: (nombre, r) => (
      <Link to={`${paths.admin.clientes.detail(r.id_cliente)}?tab=ascensores`}>{nombre}</Link>
    ),
    ellipsis: true,
  },
  {
    title: 'Cliente',
    dataIndex: 'cliente',
    key: 'cliente',
    ellipsis: true,
  },
  {
    title: 'Marca',
    dataIndex: 'marca',
    key: 'marca',
    render: (v) => v || '—',
    width: 100,
  },
  {
    title: 'Mant.',
    dataIndex: 'mantenciones',
    key: 'mantenciones',
    width: 70,
  },
  {
    title: 'Críticos',
    dataIndex: 'criticos',
    key: 'criticos',
    width: 90,
    render: (v) =>
      v > 0 ? <Tag color="red">{v}</Tag> : <Tag color="default">0</Tag>,
    sorter: (a, b) => a.criticos - b.criticos,
  },
  {
    title: '% Falla',
    dataIndex: 'pct_falla',
    key: 'pct_falla',
    width: 100,
    render: (v) => (
      <Tag color={v >= 25 ? 'red' : v >= 15 ? 'orange' : 'default'}>{v}%</Tag>
    ),
    sorter: (a, b) => a.pct_falla - b.pct_falla,
  },
  {
    title: 'Emerg. (12m)',
    dataIndex: 'emergencias',
    key: 'emergencias',
    width: 110,
  },
  {
    title: 'Health score',
    dataIndex: 'health_score',
    key: 'health_score',
    render: (v) => (
      <Progress
        percent={Math.min(100, v)}
        strokeColor={v >= 30 ? '#f5222d' : v >= 20 ? '#faad14' : '#52c41a'}
        size="small"
        format={(p) => `${v}`}
      />
    ),
    sorter: (a, b) => a.health_score - b.health_score,
    defaultSortOrder: 'descend',
    width: 180,
  },
];

function AscensoresConflictivosTile({ data, loading }) {
  if (loading)
    return <Card title="Ascensores más conflictivos" loading />;
  if (!data || data.length === 0) {
    return (
      <Card title="Ascensores más conflictivos">
        <Empty description="Sin ascensores en el ranking" />
      </Card>
    );
  }

  return (
    <Card title="Ascensores más conflictivos (falla preventiva + emergencias 12m)">
      <Table
        dataSource={data}
        columns={columns}
        rowKey="id_ascensor"
        pagination={false}
        size="small"
      />
    </Card>
  );
}

export default AscensoresConflictivosTile;
